// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@conklin/XDL/types";

import accordion from "@conklin/XDL/PreStyle/accordion";
import breadcrumbs from "@conklin/XDL/PreStyle/breadcrumbs";
import breakpoints from "@conklin/XDL/PreStyle/breakpoints";
import button from "@conklin/XDL/PreStyle/button";
import checkbox from "@conklin/XDL/PreStyle/checkbox";
import colors from "@conklin/XDL/PreStyle/colors";
import dataTable from "@conklin/XDL/PreStyle/dataTable";
import datePicker from "@conklin/XDL/PreStyle/datePicker";
import drawer from "@conklin/XDL/PreStyle/drawer";
import dynamicDropdown from "@conklin/XDL/PreStyle/dynamicDropdown";
import focus from "@conklin/XDL/PreStyle/focus";
import footer from "@conklin/XDL/PreStyle/footer";
import formField from "@conklin/XDL/PreStyle/formField";
import globalStyle from "@conklin/XDL/PreStyle/globalStyle";
import header from "@conklin/XDL/PreStyle/header";
import icon from "@conklin/XDL/PreStyle/icon";
import link from "@conklin/XDL/PreStyle/link";
import loadingSpinner from "@conklin/XDL/PreStyle/loadingSpinner";
import modal from "@conklin/XDL/PreStyle/modal";
import overflowMenu from "@conklin/XDL/PreStyle/overflowMenu";
import pagination from "@conklin/XDL/PreStyle/pagination";
import panelMenu from "@conklin/XDL/PreStyle/panelMenu";
import radio from "@conklin/XDL/PreStyle/radio";
import select from "@conklin/XDL/PreStyle/select";
import shadows from "@conklin/XDL/PreStyle/shadows";
import tab from "@conklin/XDL/PreStyle/tab";
import tag from "@conklin/XDL/PreStyle/tag";
import textArea from "@conklin/XDL/PreStyle/textArea";
import toast from "@conklin/XDL/PreStyle/toast";
import tooltip from "@conklin/XDL/PreStyle/tooltip";
import typography from "@conklin/XDL/PreStyle/typography";
import zIndex from "@conklin/XDL/PreStyle/zIndex";

export default {
    breakpoints,
    colors,
    focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    header,
    formField,
    // fieldSet,
    footer,
    icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    // lists,
    // lazyImage,
    // loadingOverlay,
    loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    // swatch,
    tab,
    tag,
    // tagsField,
    // textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
} as xBaseTheme;
